var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"home"}},[_c('hero'),_vm._v(" "),_c('home-service'),_vm._v(" "),_c('work-cta'),_vm._v(" "),_c('testimonials'),_vm._v(" "),_c('studios',[_c('h2',{attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Studios Made For "),_c('span',[_vm._v("Esports")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }